export { default as PartnerLogo } from './src/PartnerLogo';
export { default as PartnerAvatar } from './src/PartnerAvatar';
